module.exports = __webpack_public_path__ + "img/map-of-china.17df7f6e.svg";